import { Currency, FeeType, Mission, MissionStatus } from '@/shared/types/missions';

const ISO = '2025-01-15T10:00:00.000Z';

/**
 * Missions du consultant connecté, indexées par identifiant utilisateur.
 *
 * Ces missions constituent la source de vérité (côté mock) partagée entre :
 *  - l'historique des missions du dashboard consultant (`GET /api/v1/missions`) ;
 *  - les options d'activité « Projet » du CRA (chaque projet du CRA référence une mission) ;
 *  - l'activité projet par défaut et les bornes de contrat du CRA.
 */
const missionsByUser: Record<string, Mission[]> = {
  // Utilisateur mock (voir auth.mock.ts)
  user_123: [
    {
      id: 'mission-optim-net',
      title: 'Optim.Net',
      consultantId: 'user_123',
      consultantName: 'John Doe',
      clientId: 'client_cacib',
      clientName: 'CACIB',
      startDate: '2025-01-13',
      endDate: null,
      estimatedEndDate: null,
      feeType: FeeType.DAY,
      rate: 650,
      initialDuration: 12,
      paymentDelay: 45,
      currency: Currency.EUR,
      usesTimesheet: true,
      usesFixedMilestones: false,
      status: MissionStatus.ACTIVE,
      location: 'Paris La Défense',
      isTrainingMission: false,
      specificManagementFeeRate: false,
      timesheetValidatedByClient: true,
      refundableNdf: true,
      timesheetJustificationRequired: false,
      generateTimesheetPdfAutomatically: true,
      createdAt: ISO,
      updatedAt: ISO,
    },
    {
      id: 'mission-plateforme-rh',
      title: 'Plateforme RH',
      consultantId: 'user_123',
      consultantName: 'John Doe',
      clientId: 'client_sgcib',
      clientName: 'SGCIB',
      startDate: '2024-10-01',
      endDate: '2025-02-28',
      estimatedEndDate: '2025-02-28',
      feeType: FeeType.DAY,
      rate: 600,
      initialDuration: 5,
      paymentDelay: 30,
      currency: Currency.EUR,
      usesTimesheet: true,
      usesFixedMilestones: false,
      status: MissionStatus.COMPLETED,
      location: 'Paris',
      isTrainingMission: false,
      specificManagementFeeRate: false,
      timesheetValidatedByClient: false,
      refundableNdf: false,
      timesheetJustificationRequired: false,
      generateTimesheetPdfAutomatically: false,
      createdAt: ISO,
      updatedAt: ISO,
    },
  ],
};

/** Missions du consultant connecté (vide si aucune mission n'est associée). */
export function getMissionsForUser(userId: string): Mission[] {
  return missionsByUser[userId] ?? [];
}
